import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IConfigurationGroup, IConfigurationGroupCare, IResponseWithLoading } from "App/Modules/Models";
import { DayTypeFunctions } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class SiteConfigurationGroupCareComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmModalService", "mmSitesRepository"];

    public configurationGroup: IConfigurationGroup;

    public deleted: (params: { id: string }) => void;

    public configurationGroupCare: IResponseWithLoading<IConfigurationGroupCare>;

    public dayTypes = DayTypeFunctions.WeekDaysMap();

    constructor(
        private readonly $scope: IScope,
        private readonly modalService: IModalService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(
            this.sitesRepository.getConfigurationGroupCare(this.configurationGroup.siteId, this.configurationGroup.id),
        )
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result: IResponseWithLoading<IConfigurationGroupCare>) => {
                    this.configurationGroupCare = result;
                },
                (result) => {
                    this.configurationGroupCare = result;
                },
            );
    }

    public editConfiguration() {
        this.modalService
            .open<IConfigurationGroupCare, void>(
                "mmConfigurationGroupCareEdit",
                this.configurationGroupCare.data,
                null,
                "lg",
            )
            .subscribe(
                (editedConfiguration) => {
                    if (editedConfiguration !== null) {
                        this.configurationGroupCare.data = editedConfiguration;
                        this.configurationGroup.name = editedConfiguration.name;
                    } else {
                        this.deleted({ id: this.configurationGroup.id });
                    }
                },
                (reason) => reason,
            );
    }
}
